import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BrandingProvider } from './context/BrandingContext';
import AdminOperadora from './pages/AdminOperadora';
import AdminQualidadeDado from './pages/AdminQualidadeDado';
import IndicadoresAns from './pages/IndicadoresAns';
import Login from './pages/Login';
import RecuperarSenha from './pages/RecuperarSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import MainLayout from './components/MainLayout';
import Busca from './pages/Busca';
import Beneficiario from './pages/Beneficiario';
import BeneficiarioDetalhe from './pages/BeneficiarioDetalhe';
import Kanban from './pages/Kanban';
// NovoAtendimento removido - fluxo unificado no modal do Kanban
import Atendimento from './pages/Atendimento';
import AdminSetores from './pages/AdminSetores';
import AdminUsuarios from './pages/AdminUsuarios';
import AdminPerfisAcesso from './pages/AdminPerfisAcesso';
import AdminSistemasPlugados from './pages/AdminSistemasPlugados';
import SistemaPlugado from './pages/SistemaPlugado';
import AdminAuditoriaModulos from './pages/AdminAuditoriaModulos';
import AdminHistoricoAcessos from './pages/AdminHistoricoAcessos';
import AdminBeneficiarios from './pages/AdminBeneficiarios';
import AdminPesquisas from './pages/AdminPesquisas';
import AdminEmails from './pages/AdminEmails';
import DashboardAtendimentos from './pages/DashboardAtendimentos';
import DashboardInadimplencia from './pages/DashboardInadimplencia';
import DashboardAdocaoApp from './pages/DashboardAdocaoApp';
import AdminOnly from './components/AdminOnly';
import { RotaModulo } from './components/Acesso';
import AdminGestaoDocumentos from './pages/AdminGestaoDocumentos';
import AdminConfigAtendimento from './pages/AdminConfigAtendimento';
import NPSPesquisa from './pages/NPSPesquisa';
import CSATPesquisa from './pages/CSATPesquisa';
import AcompanharProtocolo from './pages/AcompanharProtocolo';
import AdminAcompanhamento from './pages/AdminAcompanhamento';
import WhatsApp from './pages/WhatsApp';
import TemplatesEmail from './pages/TemplatesEmail';
import RadarCarteira from './pages/RadarCarteira';
import PanoramaCarteira from './pages/PanoramaCarteira';
import Relatorios from './pages/Relatorios';
import DFC from './pages/DFC';
import ResultadoPlano from './pages/ResultadoPlano';
import InteligenciaCusto from './pages/InteligenciaCusto';
import SalaAoVivo from './pages/SalaAoVivo';
import ProducaoReembolso from './pages/ProducaoReembolso';
import InternacoesProrrogadas from './pages/InternacoesProrrogadas';
import DemonstracoesContabeis from './pages/contabilidade/DemonstracoesContabeis';
import PainelDiretoria from './pages/contabilidade/PainelDiretoria';
import AdminCardapioTarefas from './pages/AdminCardapioTarefas';
import AuditoriaBancaria from './pages/AuditoriaBancaria';
// === Módulo de Inovação ===
import InovacaoHome from './pages/inovacao/InovacaoHome';
import MeuTrabalho from './pages/inovacao/MeuTrabalho';
import AdminCustosHora from './pages/inovacao/AdminCustosHora';
import AnaliseLista from './pages/inovacao/AnaliseLista';
import NovaAnalise from './pages/inovacao/NovaAnalise';
import AnaliseDetalhe from './pages/inovacao/AnaliseDetalhe';
import AnalisePublica from './pages/inovacao/AnalisePublica';
import AprovacaoPublica from './pages/inovacao/AprovacaoPublica';
import ProjetoLista from './pages/inovacao/ProjetoLista';
import NovoProjeto from './pages/inovacao/NovoProjeto';
import ProjetoWorkspace from './pages/inovacao/ProjetoWorkspace';
import GanttConsolidado from './pages/inovacao/GanttConsolidado';
import DashboardApetite from './pages/inovacao/DashboardApetite';
import CargaPessoas from './pages/inovacao/CargaPessoas';
import { ReleaseLista, ReleaseDetalhe } from './pages/inovacao/Releases';
import RetrospectivaDepoimento from './pages/inovacao/RetrospectivaDepoimento';
import AdminInovacao from './pages/inovacao/AdminInovacao';
import TemplatesProjeto from './pages/inovacao/TemplatesProjeto';
// === Módulo Fabricante (painel do dono do produto) ===
import GestaoEmpresas from './pages/fabricante/GestaoEmpresas';
import TrilhaAcesso from './pages/fabricante/TrilhaAcesso';
// === Módulo Academia (Universidade) ===
import AcademiaAluno from './pages/academia/AcademiaAluno';
import AcademiaCurso from './pages/academia/AcademiaCurso';
// === Serviços (módulos Sabor B embutidos por iframe) ===
import ImportacaoBrasindice from './pages/servicos/ImportacaoBrasindice';

// Componente para rotas protegidas
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Sistema plugado (ADR 0016): o código vem da URL e é o mesmo do módulo no catálogo.
function RotaSistemaPlugado() {
  const { codigo } = useParams();
  return <RotaModulo codigo={codigo}><SistemaPlugado key={codigo} /></RotaModulo>;
}

function App() {
  return (
    <BrandingProvider>
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Recuperacao de senha (publicas) — link no e-mail aponta pra /redefinir-senha/:token */}
          <Route path="/recuperar-senha" element={<RecuperarSenha />} />
          <Route path="/redefinir-senha/:token" element={<RedefinirSenha />} />
          {/* Rotas publicas pesquisas */}
          <Route path="/nps/:token" element={<NPSPesquisa />} />
          <Route path="/pesquisa/:token" element={<CSATPesquisa />} />
          {/* Rota publica acompanhamento de protocolo */}
          <Route path="/acompanhar/:protocolo" element={<AcompanharProtocolo />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/kanban" />} />
            <Route path="busca" element={<RotaModulo codigo="busca"><Busca /></RotaModulo>} />
            <Route path="beneficiario/:id" element={<RotaModulo codigo="busca"><Beneficiario /></RotaModulo>} />
            <Route path="beneficiario-detalhe/:cpf" element={<RotaModulo codigo="busca"><BeneficiarioDetalhe /></RotaModulo>} />
            <Route path="beneficiario/:id/novo-atendimento" element={<Navigate to="/kanban" />} />
            <Route path="novo-atendimento/:cpf" element={<Navigate to="/kanban" />} />
            <Route path="kanban" element={<RotaModulo codigo="kanban"><Kanban /></RotaModulo>} />
            <Route path="atendimento/:id" element={<RotaModulo codigo="kanban"><Atendimento /></RotaModulo>} />
            <Route path="whatsapp" element={<RotaModulo codigo="whatsapp"><WhatsApp /></RotaModulo>} />
            <Route path="admin/setores" element={<RotaModulo codigo="admin_setores"><AdminSetores /></RotaModulo>} />
            <Route path="admin/usuarios" element={<RotaModulo codigo="admin_usuarios"><AdminUsuarios /></RotaModulo>} />
            <Route path="admin/perfis-acesso" element={<RotaModulo codigo="admin_usuarios"><AdminPerfisAcesso /></RotaModulo>} />
            <Route path="admin/sistemas-plugados" element={<RotaModulo codigo="admin_usuarios"><AdminSistemasPlugados /></RotaModulo>} />
            <Route path="admin/auditoria-modulos" element={<RotaModulo codigo="auditoria_modulos"><AdminAuditoriaModulos /></RotaModulo>} />
            <Route path="admin/historico-acessos" element={<RotaModulo codigo="admin_usuarios"><AdminHistoricoAcessos /></RotaModulo>} />
            <Route path="admin/operadora" element={<RotaModulo codigo="admin_operadora"><AdminOperadora /></RotaModulo>} />
            <Route path="admin/beneficiarios" element={<RotaModulo codigo="admin_beneficiarios"><AdminBeneficiarios /></RotaModulo>} />
            <Route path="admin/qualidade-dado" element={<RotaModulo codigo="admin_qualidade_dado"><AdminQualidadeDado /></RotaModulo>} />
            <Route path="indicadores-ans" element={<RotaModulo codigo="indicadores_ans"><IndicadoresAns /></RotaModulo>} />
            <Route path="admin/pesquisas" element={<RotaModulo codigo="pesquisas"><AdminPesquisas /></RotaModulo>} />
            <Route path="admin/emails" element={<RotaModulo codigo="emails"><AdminEmails /></RotaModulo>} />
            <Route path="dashboard/atendimentos" element={<RotaModulo codigo="dashboard_atendimentos"><DashboardAtendimentos /></RotaModulo>} />
            <Route path="sala-ao-vivo" element={<RotaModulo codigo="sala_ao_vivo"><SalaAoVivo /></RotaModulo>} />
            <Route path="producao/reembolso" element={<RotaModulo codigo="producao_reembolso"><ProducaoReembolso /></RotaModulo>} />
            <Route path="internacoes-prorrogadas" element={<RotaModulo codigo="radar_carteira"><InternacoesProrrogadas /></RotaModulo>} />
            <Route path="internacoes-prorrogadas/:guia" element={<RotaModulo codigo="radar_carteira"><InternacoesProrrogadas /></RotaModulo>} />
            <Route path="dashboard/inadimplencia" element={<RotaModulo codigo="dashboard_inadimplencia"><DashboardInadimplencia /></RotaModulo>} />
            <Route path="dashboard/adocao-app" element={<RotaModulo codigo="dashboard_adocao_app"><DashboardAdocaoApp /></RotaModulo>} />
            <Route path="relatorios" element={<RotaModulo codigo="relatorios"><Relatorios /></RotaModulo>} />
            <Route path="admin/documentos" element={<RotaModulo codigo="admin_documentos"><AdminGestaoDocumentos /></RotaModulo>} />
            <Route path="admin/config-atendimentos" element={<RotaModulo codigo="admin_config_atendimentos"><AdminConfigAtendimento /></RotaModulo>} />
            <Route path="admin/cardapio-tarefas" element={<RotaModulo codigo="admin_config_atendimentos"><AdminCardapioTarefas /></RotaModulo>} />
            <Route path="admin/acompanhamento" element={<RotaModulo codigo="acompanhamento"><AdminAcompanhamento /></RotaModulo>} />
            <Route path="admin/templates-email" element={<RotaModulo codigo="templates_email"><TemplatesEmail /></RotaModulo>} />
            <Route path="radar-carteira" element={<RotaModulo codigo="radar_carteira"><RadarCarteira /></RotaModulo>} />
            <Route path="panorama-carteira" element={<RotaModulo codigo="radar_carteira"><PanoramaCarteira /></RotaModulo>} />
            <Route path="dfc" element={<RotaModulo codigo="dfc"><DFC /></RotaModulo>} />
            <Route path="resultado-plano" element={<RotaModulo codigo="resultado_plano"><ResultadoPlano /></RotaModulo>} />
            {/* Inteligência de Custo: mesmos dados de utilização, mesma permissão do Resultado por Plano */}
            <Route path="inteligencia-custo" element={<RotaModulo codigo="inteligencia_custo"><InteligenciaCusto /></RotaModulo>} />
            {/* Área Contabilidade: o item do menu abre a primeira tela da área */}
            <Route path="contabilidade" element={<Navigate to="/resultado-plano" replace />} />
            <Route path="contabilidade/demonstracoes" element={<RotaModulo codigo="resultado_plano"><DemonstracoesContabeis /></RotaModulo>} />
            <Route path="contabilidade/diretoria" element={<RotaModulo codigo="resultado_plano"><PainelDiretoria /></RotaModulo>} />
            <Route path="auditoria-bancaria" element={<AdminOnly><AuditoriaBancaria /></AdminOnly>} />
            {/* === Módulo Fabricante (backend valida papel fabricante_admin) === */}
            <Route path="fabricante/empresas" element={<AdminOnly><GestaoEmpresas /></AdminOnly>} />
            <Route path="fabricante/trilha" element={<AdminOnly><TrilhaAcesso /></AdminOnly>} />
            {/* === Módulo de Inovação (rotas privadas) === */}
            <Route path="inovacao" element={<RotaModulo codigo="inovacao"><InovacaoHome /></RotaModulo>} />
            <Route path="inovacao/meu-trabalho" element={<RotaModulo codigo="inovacao"><MeuTrabalho /></RotaModulo>} />
            <Route path="inovacao/admin/custos-hora" element={<RotaModulo codigo="inovacao"><AdminCustosHora /></RotaModulo>} />
            <Route path="inovacao/analises" element={<RotaModulo codigo="inovacao"><AnaliseLista /></RotaModulo>} />
            <Route path="inovacao/analises/nova" element={<RotaModulo codigo="inovacao"><NovaAnalise /></RotaModulo>} />
            <Route path="inovacao/analises/:id" element={<RotaModulo codigo="inovacao"><AnaliseDetalhe /></RotaModulo>} />
            <Route path="inovacao/analise/:token" element={<AnalisePublica />} />
            <Route path="inovacao/aprovacao/:token" element={<AprovacaoPublica />} />
            <Route path="inovacao/projetos" element={<RotaModulo codigo="inovacao"><ProjetoLista /></RotaModulo>} />
            <Route path="inovacao/projetos/novo" element={<RotaModulo codigo="inovacao"><NovoProjeto /></RotaModulo>} />
            <Route path="inovacao/projetos/:id" element={<RotaModulo codigo="inovacao"><ProjetoWorkspace /></RotaModulo>} />
            <Route path="inovacao/gantt" element={<RotaModulo codigo="inovacao"><GanttConsolidado /></RotaModulo>} />
            <Route path="inovacao/dashboard" element={<RotaModulo codigo="inovacao"><DashboardApetite /></RotaModulo>} />
            <Route path="inovacao/carga-pessoas" element={<RotaModulo codigo="inovacao"><CargaPessoas /></RotaModulo>} />
            <Route path="inovacao/releases" element={<RotaModulo codigo="inovacao"><ReleaseLista /></RotaModulo>} />
            <Route path="inovacao/releases/:id" element={<RotaModulo codigo="inovacao"><ReleaseDetalhe /></RotaModulo>} />
            <Route path="inovacao/retrospectiva/:token/depoimento" element={<RetrospectivaDepoimento />} />
            <Route path="inovacao/admin" element={<RotaModulo codigo="inovacao"><AdminInovacao /></RotaModulo>} />
            <Route path="inovacao/templates" element={<RotaModulo codigo="inovacao"><TemplatesProjeto /></RotaModulo>} />
            {/* === Módulo Academia (Universidade) === */}
            <Route path="academia" element={<RotaModulo codigo="academia"><AcademiaAluno /></RotaModulo>} />
            <Route path="academia/curso/:id" element={<RotaModulo codigo="academia"><AcademiaCurso /></RotaModulo>} />
            {/* === Serviços (ADR 0012: Importação Brasíndice, módulo Sabor B) === */}
            <Route path="servicos/brasindice" element={<RotaModulo codigo="brasindice"><ImportacaoBrasindice /></RotaModulo>} />
            <Route path="plug/:codigo" element={<RotaSistemaPlugado />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </BrandingProvider>
  );
}

export default App;
